export type UndefinedToNulled<T, Keys extends keyof T> = {
    [K in Keys]-?: Exclude<T[K], undefined> | null;
};

/**
 * Will convert all undefined values specified in keys in an object to null keys
 *
 * @param obj - The object
 * @param mandatory - You need to pass at least 1 key
 * @param {...any} keys - The keys of the object to ensure are either null or set
 * @returns - The object with forced set values
 */
export function undefinedToNull<T, Keys extends keyof T>(
    obj: T,
    mandatory: Keys,
    ...keys: Keys[]
): UndefinedToNulled<T, Keys>;
export function undefinedToNull<T, Keys extends keyof T>(obj: T, ...keys: Keys[]): UndefinedToNulled<T, Keys> {
    const newObject: UndefinedToNulled<T, Keys> = {
        ...(obj as any),
    };

    for (const key of keys) {
        if (typeof newObject[key] === 'undefined' || newObject[key] === undefined) {
            newObject[key] = null;
        }
    }
    return newObject;
}
